import { keepPreviousData, useQuery, useQueryClient } from "@tanstack/react-query";
import { useSocialCoachSession } from "./useSocialCoachSession";
import { PostSearchQuery, PostServices } from "@/services/bedrock";

export const usePostSearch = () => {
  const { coachId } = useSocialCoachSession();
  const queryClient = useQueryClient();

  const searchPosts = (params: PostSearchQuery) => {
    const sortedStatuses = params.statuses?.slice().sort() || [];
    const sortedSegmentKeys = params.segmentationIds?.slice().sort() || [];
    const sortedPlayerIds = params.playerIds?.slice().sort() || [];
    const sortedSourceTypes = params.sourceTypes?.slice().sort() || [];
    const sortedMediaTypes = params.mediaTypes?.slice().sort() || [];
    const sortedPolicyTypes = params.keyphrasePolicies?.slice().sort() || [];
    const sortedKeyphraseIds = params.keyphraseIds?.slice().sort() || [];
    const sortedReviewStatuses = params.reviewStatuses?.slice().sort() || [];
    const { data: posts, isFetching } = useQuery({
      queryKey: [
        "coachPostList",
        coachId,
        params.page,
        params.from,
        params.until,
        sortedStatuses,
        sortedSegmentKeys,
        sortedPlayerIds,
        sortedSourceTypes,
        sortedMediaTypes,
        sortedPolicyTypes,
        sortedKeyphraseIds,
        sortedReviewStatuses,
      ],
      queryFn: async () => {
        return PostServices.search(params);
      },
      placeholderData: keepPreviousData,
      staleTime: 1000 * 60, // 1 minute
    });
    return { posts, isFetching };
  };

  const clearPostSearchCache = () => {
    queryClient.invalidateQueries({ queryKey: ["coachPostList", coachId] }).catch(console.error);
  };

  return {
    searchPosts,
    clearPostSearchCache,
  };
};
